export const messages = {
  en: {
    accountManage: {
      searchTitle: "Search Conditions",
      ownerAccount: "Owner Account",
      accountId: "Account ID",
      accountName: "Account Name",
      idCard: "ID Card",
      phone: "Phone",
      accountType: "Account Type",
      accountAmount: "Account Amount",
      deductionRoom: "Deduction Room",
      createTime: "Create Time",
      operations: "Operations",
      accountDetail: "Account Details",
      delete: "Delete",
      prestore: "Prestore",
      importPrestore: "Import Prestore",
      query: "Query",
      reset: "Reset",
      placeholderName: "Please enter account name",
      placeholderRoom: "Please enter room number",
      room: "Room"
    },
    prestoreAccount: {
      title: "Prestore",
      accountType: "Account Type",
      room: "Room",
      ownerPhone: "Owner Phone",
      ownerName: "Owner Name",
      deductionRoom: "Deduction Room",
      prestoreAmount: "Prestore Amount",
      paymentMethod: "Payment Method",
      remark: "Remark",
      placeholderPhone: "Required, please enter owner phone",
      placeholderOwner: "Required, please select owner",
      placeholderRoom: "Required, please select room",
      placeholderAmount: "Required, please enter prestore amount",
      placeholderPayment: "Required, please select payment method",
      placeholderRemark: "Optional, please enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    deleteAccount: {
      title: "Please confirm your operation!",
      confirmDelete: "Confirm to delete deposit?",
      cancel: "Cancel",
      confirm: "Confirm Delete"
    },
    importAccount: {
      title: "Batch Import Prestore",
      accountType: "Account Type",
      selectFile: "Select File",
      fileRequired: "Please select an Excel file",
      invalidExcel: "Please select a valid Excel file",
      fileSizeExceed: "File size exceeds limit (10MB)",
      importTemplate: "Template",
      downloadTemplate: "Download Template",
      downloadFirst: "Please download ",
      prepareData: " first, fill in data according to the template format",
      import: "Import",
      importDesc: "Template fields: Account Name, ID Card, Phone, Prestore Amount, Remark",
      importDesc2004: "Template fields: Room ID, Room Name, Prestore Amount, Remark",
      importDesc2005: "Template fields: Room ID, Room Name, Prestore Amount, Remark",
      importDesc2006: "Template fields: Room ID, Room Name, Prestore Amount, Remark",
      importResult: "Total {total}, Success {success}, Fail {fail}",
      downloadSuccess: "Template downloaded successfully",
      downloadFail: "Template download failed"
    }
  },
  zh: {
    accountManage: {
      searchTitle: "查询条件",
      ownerAccount: "业主账户",
      accountId: "账户编号",
      accountName: "账户名称",
      idCard: "身份证号",
      phone: "手机号",
      accountType: "账户类型",
      accountAmount: "账户金额",
      deductionRoom: "扣款房号",
      createTime: "创建时间",
      operations: "操作",
      accountDetail: "账户明细",
      delete: "删除",
      prestore: "预存",
      importPrestore: "批量导入预存",
      query: "查询",
      reset: "重置",
      placeholderName: "请输入账户名称",
      placeholderRoom: "请输入房屋编号",
      room: "房屋"
    },
    prestoreAccount: {
      title: "预存",
      accountType: "账户类型",
      room: "房屋",
      deductionRoom: "扣款房屋",
      prestoreAmount: "预存金额",
      paymentMethod: "支付方式",
      remark: "备注",
      placeholderPhone: "必填，请填写业主手机号",
      placeholderOwner: "必填，请选择业主",
      placeholderRoom: "必填，请选择房屋",
      placeholderAmount: "必填，请填写预存金额",
      placeholderPayment: "必填，请选择支付方式",
      placeholderRemark: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteAccount: {
      title: "请确认您的操作!",
      confirmDelete: "确定删除保证金",
      cancel: "点错了",
      confirm: "确认删除"
    },
    importAccount: {
      title: "批量导入预存",
      accountType: "账户类型",
      selectFile: "选择文件",
      fileRequired: "请选择Excel文件",
      invalidExcel: "请选择有效的Excel文件(.xlsx/.xls)",
      fileSizeExceed: "文件大小不能超过10MB",
      importTemplate: "模板",
      downloadTemplate: "下载模板",
      downloadFirst: "请先下载",
      prepareData: "，按模板格式填写数据后导入",
      import: "导入",
      importDesc: "模板列：账户名称、身份证号、联系方式、预存金额、备注",
      importDesc2004: "模板列：房屋编号、房屋名称、预存金额、备注",
      importDesc2005: "模板列：房屋编号、房屋名称、预存金额、备注",
      importDesc2006: "模板列：房屋编号、房屋名称、预存金额、备注",
      importResult: "共 {total} 条，成功 {success} 条，失败 {fail} 条",
      downloadSuccess: "模板下载成功",
      downloadFail: "模板下载失败"
    }
  }
}